import OfficeList from '@/views/App/OfficeAudit/Audit/OfficeList.vue';
import AuditList from '@/views/App/OfficeAudit/Audit/AuditList.vue';
import AuditForm from '@/views/App/OfficeAudit/Audit/AuditForm.vue';
import AuditMonthlyCalendar from '@/views/App/OfficeAudit/Calendar/MonthlyCalendar.vue';
import AuditWeeklyCalendar from '@/views/App/OfficeAudit/Calendar/WeeklyCalendar.vue';

const routesOfficeAudit = [
    {
        path: 'office-list',
        name: 'auditOfficeList',
        component: OfficeList
    },
    {
        path: 'list/:officeId',
        name: 'auditList',
        component: AuditList
    },
    {
        path: 'form/:officeId',
        name: 'auditFormCreate',
        component: AuditForm
    },
    {
        path: 'form/:officeId/:id',
        name: 'auditFormUpdate',
        component: AuditForm
    },
    {
        path: 'monthly-calendar',
        name: 'auditMonthlyCalendar',
        component: AuditMonthlyCalendar
    },
    {
        path: 'weekly-calendar',
        name: 'auditWeeklyCalendar',
        component: AuditWeeklyCalendar
    },
];

export default routesOfficeAudit;